import Row from '@components/row'
import { StyleCard, StyleTag } from './style'
import ScheduleCard from '../../schedule'
import Typography from '@components/typography'
import Status from '@commons/status'
import { FC } from 'react'
interface AppointmentInfoCardProps {
  id: number
  status: string
  paymentStatus: string
  date: any
  appointmentType: string
}
const AppointmentInfoCard: FC<AppointmentInfoCardProps> = ({
  id,
  status,
  paymentStatus,
  date,
  appointmentType,
}) => {
  return (
    <StyleCard>
      <Row justifyContent="space-between" alignItems="center">
        <Typography content={`ID:#${id}`} size={14} tc="text" />
        <Status status={status} />
        <Status status={paymentStatus} />
        <StyleTag>
          {appointmentType == 'At Clinic' ? 'At Clinic' : 'Online'}
        </StyleTag>
      </Row>
      <ScheduleCard date={date} />
    </StyleCard>
  )
}

export default AppointmentInfoCard
